import { TranslationCatalog } from './translations.types';

export const AUTH_REGISTER_TRANSLATIONS: TranslationCatalog = {
  es: {
    'register.title': 'Bienvenido al equipo WeMatch',
    'register.titlemodal': 'Crea tu cuenta',
    'register.subtitle': 'Regístrate para encontrar las mejores oportunidades',
    'register.subtitlemodal': 'Completa tus datos para empezar',
    'register.field.firstName': 'Nombre',
    'register.field.lastName': 'Apellidos',
    'register.field.email': 'Correo electrónico',
    'register.field.phone': 'Número de celular',
    'register.field.password': 'Contraseña',
    'register.field.confirmPassword': 'Confirmar contraseña',
    'register.passwordGuideTitle': 'Tu contraseña debe cumplir:',
    'register.passwordRule.minLength': '8 caracteres mínimo',
    'register.passwordRule.uppercase': 'Al menos una mayúscula',
    'register.passwordRule.number': 'Al menos un número',
    'register.passwordRule.special': 'Al menos un carácter especial (! # $ % + / - ? @)',
    'register.passwordWarning.common':
      'Esta contraseña es bastante común. Te recomendamos elegir una más segura.',
    'register.passwordWarning.personalInfo':
      'Evita usar tu nombre, correo o teléfono dentro de la contraseña.',
    'register.terms1': 'Acepto los',
    'register.terms2': 'términos y condiciones',
    'register.terms3': 'de uso de la plataforma',
    'register.privacy1': 'Acepto la',
    'register.privacy2': 'política de privacidad',
    'register.privacy3': 'y el tratamiento de mis datos personales',
    'register.cta': 'Crear cuenta',
    'register.haveAccount': '¿Ya tienes una cuenta?',
    'register.login': 'Inicia sesión',
    'register.heroTitle': 'Da el siguiente paso',
    'register.heroBody':
      'Convierte tus habilidades en nuevas oportunidades dentro de nuestra plataforma. Regístrate y empieza a conectar con lo que buscas.',
    'register.modalBenefit.1': 'Completa tu perfil y deja que el algoritmo te conecte con vacantes relevantes.',
    'register.modalBenefit.2': 'Recibe oportunidades acordes con tus fortalezas y aspiraciones.',
    'register.modalBenefit.3': 'Todo el proceso es gratis para candidatos.',
    'register.error.invalidForm': 'Revisa los campos marcados y vuelve a intentarlo.',
    'register.error.firstNameRequired': 'Ingresa tu nombre.',
    'register.error.lastNameRequired': 'Ingresa tus apellidos.',
    'register.error.namePattern': 'Usa solo letras, espacios, guiones o apóstrofes.',
    'register.error.nameMin': 'Ingresa al menos 2 caracteres.',
    'register.error.nameMax': 'Este campo admite máximo 75 caracteres.',
    'register.error.emailRequired': 'Ingresa tu correo electrónico.',
    'register.error.emailInvalid': 'Ingresa un correo electrónico válido.',
    'register.error.emailMax': 'Este campo admite máximo 254 caracteres.',
    'register.error.phoneRequired': 'Ingresa tu número de celular.',
    'register.error.phoneTooShort': 'El número es demasiado corto para el país seleccionado.',
    'register.error.phoneTooShortCountry': 'El número parece incompleto para {country}.',
    'register.error.phoneTooShortExample':
      'El teléfono ingresado no es válido para el país seleccionado. Ej: {example}',
    'register.error.phoneTooShortCountryExample':
      'El número parece incompleto para {country}. Ej: {example}',
    'register.error.phoneTooLong': 'El número supera la longitud permitida para el país seleccionado.',
    'register.error.phoneTooLongCountry': 'El número supera la longitud esperada para {country}.',
    'register.error.phoneTooLongExample':
      'El teléfono ingresado no es válido para el país seleccionado. Ej: {example}',
    'register.error.phoneTooLongCountryExample':
      'El número supera la longitud esperada para {country}. Ej: {example}',
    'register.error.phoneInvalid': 'Verifica que el número sea válido para el país seleccionado.',
    'register.error.phoneInvalidCountry':
      'Verifica que el número corresponda a un celular válido de {country}.',
    'register.error.phoneInvalidExample':
      'El teléfono ingresado no es válido para el país seleccionado. Ej: {example}',
    'register.error.phoneInvalidCountryExample':
      'Verifica que el número corresponda a un celular válido de {country}. Ej: {example}',
    'register.error.passwordRequired': 'Ingresa una contraseña.',
    'register.error.passwordRules': 'La contraseña debe cumplir con los requisitos indicados.',
    'register.error.confirmRequired': 'Confirma tu contraseña.',
    'register.error.passwordMismatch': 'Las contraseñas no coinciden.',
    'register.notice.registerFailed': 'No pudimos completar el registro. Intenta nuevamente.',
    'register.notice.emailInvalid':
      'Revisa tu correo electrónico. Debe tener un formato válido y no incluir caracteres no permitidos.',
    'register.notice.pendingVerificationUnavailable':
      'Tu registro quedó pendiente de verificación, pero aún no podemos continuar con el envío del código. Intenta nuevamente en unos minutos.',
    'register.notice.emailExists':
      'Parece que este correo ya está registrado. Inicia sesión con el correo de tu cuenta para continuar.',
    'register.notice.phoneInvalid':
      'Revisa tu número de celular. Debe corresponder a un formato válido para el país seleccionado.',
    'register.notice.phoneExists':
      'Parece que este número ya está registrado. Usa el acceso de tu cuenta o intenta con otro número.',
    'register.notice.badRequest': 'Revisa los datos ingresados y vuelve a intentarlo.',
    'register.notice.serverError': 'No pudimos procesar el registro. Intenta nuevamente.',
    'register.notice.otpFailed': 'No pudimos enviar el código de verificación. Intenta nuevamente.',
    'register.notice.googlePending': 'El acceso con Google estará disponible pronto.',
    'success.title': 'Bienvenida a WeMatch!',
    'success.subtitle': '¡Listo, tu cuenta ya está registrada!',
    'success.body':
      'Para aprovechar todo el alcance de WeMatch, debes iniciar sesión con los datos que ingresaste. Así podrás buscar oportunidades, postularte, hacer seguimiento a tus procesos y usar todos los filtros disponibles.',
    'success.login': 'Iniciar sesión',
    'success.later': 'Más tarde',
  },
  en: {
    'register.title': 'Welcome to the WeMatch team',
    'register.titlemodal': 'Create your account',
    'register.subtitle': 'Sign up to find the best opportunities',
    'register.subtitlemodal': 'Complete your details to get started',
    'register.field.firstName': 'First name',
    'register.field.lastName': 'Last name',
    'register.field.email': 'Email',
    'register.field.phone': 'Mobile number',
    'register.field.password': 'Password',
    'register.field.confirmPassword': 'Confirm password',
    'register.passwordGuideTitle': 'Your password must include:',
    'register.passwordRule.minLength': 'At least 8 characters',
    'register.passwordRule.uppercase': 'At least one uppercase letter',
    'register.passwordRule.number': 'At least one number',
    'register.passwordRule.special': 'At least one special character (! # $ % + / - ? @)',
    'register.passwordWarning.common':
      'This password is quite common. We recommend choosing a stronger one.',
    'register.passwordWarning.personalInfo':
      'Avoid using your name, email, or phone number in your password.',
    'register.terms1': 'I accept the',
    'register.terms2': 'terms and conditions',
    'register.terms3': 'for using the platform',
    'register.privacy1': 'I accept the',
    'register.privacy2': 'privacy policy',
    'register.privacy3': 'and the processing of my personal data',
    'register.cta': 'Create account',
    'register.haveAccount': 'Already have an account?',
    'register.login': 'Log in',
    'register.heroTitle': 'Take the next step',
    'register.heroBody':
      'Turn your skills into new opportunities on our platform. Sign up and start connecting with what you are looking for.',
    'register.modalBenefit.1': 'Complete your profile and let the algorithm connect you with relevant jobs.',
    'register.modalBenefit.2': 'Get opportunities aligned with your strengths and ambitions.',
    'register.modalBenefit.3': 'The whole process is free for candidates.',
    'register.error.invalidForm': 'Review the highlighted fields and try again.',
    'register.error.firstNameRequired': 'Enter your first name.',
    'register.error.lastNameRequired': 'Enter your last name.',
    'register.error.namePattern': 'Use letters, spaces, hyphens, or apostrophes only.',
    'register.error.nameMin': 'Enter at least 2 characters.',
    'register.error.nameMax': 'This field supports up to 75 characters.',
    'register.error.emailRequired': 'Enter your email.',
    'register.error.emailInvalid': 'Enter a valid email address.',
    'register.error.emailMax': 'This field supports up to 254 characters.',
    'register.error.phoneRequired': 'Enter your mobile number.',
    'register.error.phoneTooShort': 'The number is too short for the selected country.',
    'register.error.phoneTooShortCountry': 'The number looks incomplete for {country}.',
    'register.error.phoneTooShortExample':
      'The phone number entered is not valid for the selected country. Example: {example}',
    'register.error.phoneTooShortCountryExample':
      'The number looks incomplete for {country}. Example: {example}',
    'register.error.phoneTooLong': 'The number exceeds the allowed length for the selected country.',
    'register.error.phoneTooLongCountry': 'The number exceeds the expected length for {country}.',
    'register.error.phoneTooLongExample':
      'The phone number entered is not valid for the selected country. Example: {example}',
    'register.error.phoneTooLongCountryExample':
      'The number exceeds the expected length for {country}. Example: {example}',
    'register.error.phoneInvalid': 'Check that the number is valid for the selected country.',
    'register.error.phoneInvalidCountry':
      'Check that the number matches a valid mobile format for {country}.',
    'register.error.phoneInvalidExample':
      'The phone number entered is not valid for the selected country. Example: {example}',
    'register.error.phoneInvalidCountryExample':
      'Check that the number matches a valid mobile format for {country}. Example: {example}',
    'register.error.passwordRequired': 'Enter a password.',
    'register.error.passwordRules': 'The password must meet the listed requirements.',
    'register.error.confirmRequired': 'Confirm your password.',
    'register.error.passwordMismatch': 'Passwords do not match.',
    'register.notice.registerFailed': 'We could not complete your registration. Please try again.',
    'register.notice.emailInvalid':
      'Check your email address. It must use a valid format and cannot include unsupported characters.',
    'register.notice.pendingVerificationUnavailable':
      'Your registration is still pending verification, but we cannot continue sending the code yet. Please try again in a few minutes.',
    'register.notice.emailExists':
      'This email is already registered. Log in with your account email to continue.',
    'register.notice.phoneInvalid':
      'Check your mobile number. It must match a valid format for the selected country.',
    'register.notice.phoneExists':
      'This number is already registered. Use your account access or try another number.',
    'register.notice.badRequest': 'Review the entered information and try again.',
    'register.notice.serverError': 'We could not process your registration. Please try again.',
    'register.notice.otpFailed': 'We could not send the verification code. Please try again.',
    'register.notice.googlePending': 'Google sign in will be available soon.',
    'success.title': 'Welcome to WeMatch!',
    'success.subtitle': 'Your account is ready!',
    'success.body':
      'To make the most of WeMatch, log in with the details you entered. You will be able to search opportunities, apply, track your processes, and use all available filters.',
    'success.login': 'Log in',
    'success.later': 'Later',
  },
};
